export default __webpack_public_path__ + "static/media/drinkwater.7c6ce760.JPG";